import { createGlobalStyle } from "styled-components";

import styled from "styled-components";
import { i18n } from "../../../services/i18nService";

export const LayoutWrapperStyled = styled.div`
  position: ${props => (props.isFullScreen === true ? "static" : "relative")};
  width: 93.958rem;
  ${props =>
    props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? `padding-left:1.8229rem` : `padding-right:1.8229rem`};
  background-color: ${props => props.theme.color.black};
  & [class*="TimeRulerStyled"] {
    position: absolute;
    direction: ltr;
  }
`;
export const LayoutEmptyStyled = styled.div`
  text-align: center;
  margin-top: 25rem;
  // margin-right: 15rem;
`;

export const PlayerWrapperStyled = styled.div`
  height: ${props => (props.isFullScreen === true ? "100%" : "50.2%")};
  background-color: ${props => props.theme.color.black};
`;

export const VideoMetaDataWrapperStyled = styled.div`
  display: inline-block;
  width: 46%;
  height: 100%;
  direction: ${props => props.direction};
`;

export const VideoWrapperStyled = styled.div`
  display: inline-block;
  width: 54%;
  height: 100%;
  float: ${props => (props.direction === "rtl" ? "left" : "right")};
  direction: ${props => props.direction};
`;

export const EPGWrapperStyled = styled.div`
  height: 48.5%;
  position: relative;
`;
export const CategoriesWrapperStyled = styled.div`
  width: 16.21rem;
  margin-top: 4rem;
  height: 100%;
  float: ${props => (props.direction === "rtl" ? "right" : "left")};
`;

export const TimeTextStyled = styled.span`
  ${props => (props.direction === "rtl" ? "margin-right" : "margin-left")}: 0.75rem;
  color: ${props => props.theme.color.white};
  font-size: 1.125rem;
`;

export const CategoriesWrapperHeadingStyled = styled.div`
  box-sizing: border-box;
  height: 2.625rem;
  width: 19.375rem;
  border: 1px solid rgba(209, 211, 212, 0.2);
  border-radius: 0 0 0.5rem 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  line-height: 2.5rem;
  float: left;
  position: absolute;
  font-size: 1.125rem;
  letter-spacing: 0.024rem;
`;

export const EpgViews = styled.section`
  height: 100%;
  float: ${props => (props.direction === "rtl" ? "right" : "left")};
  color: ${props => props.theme.color.white};
  ${props => (props.direction === "rtl" ? "margin-right" : "margin-left")}: 5rem;
  width: max-content;
  direction: ${props => props.direction};
`;

export const GridLoadingWrapper = styled.div`
  transform: translate(0%, 450%);
`;

export const ExitModel = styled.div`
  z-index: 9999990 !important;
`;

export const GlobalStyle = createGlobalStyle` 
.expandedMenu {
      z-index : ${props => (props.isFullScreen === true ? "0" : "999")} !important;
  } `;

export const ArrowsContainer = styled.div``;
export const LayoutLeftArrow = styled.div`
  width: 3.25rem;
  height: 3.25rem;
  ${props =>
    props.theme.locale.dir !== "rtl" &&
    `
    margin-left: -3.5%;
    margin-top: 10rem;
  `}
  ${props =>
    props.theme.locale.dir !== "ltr" &&
    `
    margin-right: 73%;
    margin-top: 10rem;
  `}
  position: absolute;
  z-index: 999999;
  display: none;
`;
export const LayoutRightArrow = styled.div`
  width: 3.25rem;
  height: 3.25rem;
  ${props =>
    props.theme.locale.dir !== "rtl" &&
    `
    margin-left: 73%;
    margin-top: 10rem;
    `}
  ${props =>
    props.theme.locale.dir !== "ltr" &&
    `
    margin-right: -3.5%;
    margin-top: 10rem;
  `}
    z-index: 999999;
  position: absolute;
  display: none;
`;
